import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: 568px;
`;
